import React, { useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { DialogProps } from 'shared/components/vxl/Dialog/Dialog';
import theme from 'shared/styles/theme';

const BUTTON_ROW = 1;
const BUTTON_COLUMN = 0;
const MAX_BUTTON_ROW_HEIGHT = 45;

const IOSButtonContainer = ({
  isIOSCaptiveDialog,
  dialogButtonProps,
}: DialogProps) => {
  const [buttonLayoutOrientation, setButtonLayoutOrientation] = useState(
    dialogButtonProps.length === 2 ? BUTTON_ROW : BUTTON_COLUMN,
  );

  const getLayoutOrientation = () => {
    return buttonLayoutOrientation === BUTTON_ROW
      ? styles.flexDirectionRow
      : styles.flexDirectionColumn;
  };

  return (
    <View
      style={getLayoutOrientation()}
      onLayout={(e) => {
        if (e.nativeEvent.layout.height > MAX_BUTTON_ROW_HEIGHT) {
          setButtonLayoutOrientation(BUTTON_COLUMN);
        }
      }}
    >
      {dialogButtonProps.map((item, index) => {
        const buttonFontWeight =
          (isIOSCaptiveDialog && index === 0) ||
          (!isIOSCaptiveDialog && index === dialogButtonProps.length - 1)
            ? styles.fontWeight600
            : styles.fontWeight400;

        const iOSbuttonContainerDivider = {
          borderRightWidth: undefined as number | undefined,
          borderRightColor: undefined as string | undefined,
        };

        const buttonTextColor =
          isIOSCaptiveDialog && index === dialogButtonProps.length - 1
            ? styles.iOSButtonTextColorRed
            : styles.iOSButtonTextColorBlue;

        if (buttonLayoutOrientation === BUTTON_ROW) {
          if (index === 0) {
            iOSbuttonContainerDivider.borderRightWidth = 1;
            iOSbuttonContainerDivider.borderRightColor = '#C6C6C6';
          }
        }

        return (
          <View
            key={`Button-${item.label}`}
            style={[styles.iOSButtonContainer, iOSbuttonContainerDivider]}
          >
            <Pressable
              testID={item.testID}
              onPress={() => {
                if (item.onClick) {
                  item.onClick();
                }
              }}
            >
              <View style={styles.iOSButton}>
                <Text
                  numberOfLines={
                    buttonLayoutOrientation === BUTTON_COLUMN ? 1 : 2
                  }
                  style={[
                    buttonFontWeight,
                    styles.iOSbuttonText,
                    buttonTextColor,
                  ]}
                >
                  {item.label}
                </Text>
              </View>
            </Pressable>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  flexDirectionColumn: {
    flexDirection: 'column',
  },
  flexDirectionRow: {
    flexDirection: 'row',
  },
  fontWeight400: {
    fontWeight: '400',
  },
  fontWeight600: {
    fontWeight: '600',
  },
  iOSButton: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
    justifyContent: 'center',
    minHeight: 44,
    minWidth: '50%',
  },
  iOSButtonContainer: {
    borderTopColor: '#C6C6C6',
    borderTopWidth: 1,
    zIndex: 1,
  },
  iOSButtonTextColorBlue: {
    color: '#007AFF',
  },
  iOSButtonTextColorRed: {
    color: theme.color.status.negative,
  },
  iOSbuttonText: {
    flex: 1,
    fontSize: 17,
    paddingHorizontal: theme.spacing.m,
    paddingVertical: 10,
    textAlign: 'center',
    textTransform: 'none',
  },
});

export default IOSButtonContainer;
